import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IComposedReportFilters } from 'legacy/lut/components/widgets/public/partner360/composedReport/models'
import { TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/composedReport/translations/TRANSLATION_KEYS'
import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'
import { setFilter } from 'legacy/lut/features/partner360/composedReport'
import { Table } from 'legacy/lut/library/list'
import { appGetState } from 'legacy/lut/store'
import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { Actions } from 'core-components/library/modalDialog'
import { Logic, Operator } from 'core-components/types'
import MeasureController from 'core/analytics/MeasureController'
import { useMeasureController } from 'core/analytics/useMeasureController'
import { CrudStore } from 'core/types/crudStore'

import { columns } from '../../configs'

interface IProps {
  metrics: MeasureController
  onClose: () => void
}

export const OpenSavedFilterAreaModalContent = ({ metrics, onClose }: IProps) => {
  const { startLoadData, stopLoadData } = useMeasureController(metrics)
  const userEmail = appGetState().user.email
  const crud = CrudStore.get(CrudStoreItemPartner360.JBPComposedReportFilters)

  const dispatch = useDispatch()

  const tableCrud = useMemo(() => {
    crud.setDefaultFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'CreatedBy',
          operator: Operator.EQUAL,
          value: userEmail,
        },
      ],
    })
    return crud
  }, [crud, userEmail])

  useEffect(() => {
    return crud.subscribe('change', () => {
      crud.fetch()
    })
  }, [crud, userEmail])

  const onChoose = useCallback(
    (item: IComposedReportFilters) => {
      dispatch(setFilter(item))
      onClose()
    },
    [dispatch, onClose]
  )

  return (
    <>
      <div>
        <WidgetHeader>{TRANSLATION_KEYS.savedFiltersDialogHeader}</WidgetHeader>
        <Table<IComposedReportFilters>
          key={`${TRANSLATION_KEYS.savedFiltersDialogKey}`}
          header
          columns={columns}
          source={tableCrud}
          measure={{ startLoadData, stopLoadData }}
          hasTranslate
          pagination
          rowActionsVisible="visible"
          rowActions={[
            {
              id: 'choose',
              title: 'Choose',
              icon: 'kbase kbase-check',
              action: onChoose,
            },
            {
              id: 'delete',
              action: async (item) => {
                crud.delete('1350', item)
              },
              title: 'Delete',
              icon: 'kbase kbase-delete',
            },
          ]}
        />
        <Actions
          position={'end'}
          items={[
            {
              id: 'cancel',
              label: 'Cancel',
              onClick: onClose,
              variant: 'text',
              color: 'grey',
            },
          ]}
        />
      </div>
    </>
  )
}
